/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
export const COLORS = {
  darkPurple: "#21003D",
  purple: "#7400BF",
  gold: "#F2B441",
  gradient: "linear-gradient(135deg, #21003D, #7400BF)",
  textLight: "#f3e9ff",
};
